//
import { debounce } from './utils'
const isSalesPartnerOverlay = () => !!$('.node-sales-partener-overlay').get(0)

let salesPartnerURL

const search = (salesPartnerURL, $e, params) => {
  $.getJSON(salesPartnerURL, params, (res) => {
    if (res && res.contact) {
      $('.phone', $e).html(`<a href="tel:${res.contact.phone}">T ${res.contact.phone}</a>`)
      $('.email', $e).html(`<a href="mailto:${res.contact.email}">${res.contact.email}</a>`)
    } else {
      $('.phone', $e).html(res.msg)
      $('.email', $e).html('')
    }
  })
}
const setup = ($) => {
  if (!isSalesPartnerOverlay()) {
    return
  }

  const $e = $('.node-sales-partener-overlay')

  $('.dot-1', $e).on('click', () => {
    $('.dot-1-content, .node-sales-partener-overlay-background').toggleClass('hidden')
    $('#zipcode').focus()
    // SalesPartner.setupOpenToTop()
    $(this).blur()
  })

  $('.node-sales-partener-overlay-background').on('click', (e) => {
    e.preventDefault()
    $('.dot-1', $e).trigger('click')
  })

  salesPartnerURL = $('.node-sales-partener-overlay')
    .data('url')
    .replace(/\?locale.*/, '')

  $(document).on('change', '.node-sales-partener-overlay .sg.select', (e, val) => {
    // debugger
    if (val.value === 'DE') {
      $('.zip-code', $e).removeClass('hidden')
      $('#zipcode').focus()
      // search(salesPartnerURL, $e, { country_code: 'DE' })
    } else {
      $('.zip-code', $e).addClass('hidden')
      search(salesPartnerURL, $e, { country_code: val.value })
    }
  })

  const searchFunc = function() {
    search(salesPartnerURL, $e, { country_code: 'DE', zip_code: $(this).val() })
  }
  $('#zipcode', $e).on('keyup', debounce(searchFunc, 500))
}

export default setup



// WEBPACK FOOTER //
// app/javascript/sg/js/node_sales_partner_overlay.js